import $http from '../../shared/http';
import { resolveWellKnownEndpoint } from './well_known';
resolveWellKnownEndpoint;

export const subscription = {
  namespaced: true,
  state: () => {
    return {
      pricing: [],
      currentSubscription: null,
    };
  },
  getters: {
    getPricing: (state) => state.pricing,
    getCurrentSubscription: (state) => state.currentSubscription,
  },
  mutations: {
    setPricing: (state, pricingPayload) => {
      state.pricing = pricingPayload;
    },
    setCurrentSubscription: (state, currentSubscriptionPayload) => {
      state.currentSubscription = currentSubscriptionPayload;
    },
  },
  actions: {
    async loadPricing({ commit }, { churchId }) {
      const url = resolveWellKnownEndpoint(
        'admin_api.v2.organisations.gotedo_products.pricing_table.index',
        {
          organisation_id: churchId,
          gotedo_product_id: process.env.VUE_APP_GOTEDO_VINEYARD_ID,
        }
      )?.url;

      if (!url) {
        return;
      }

      return $http('v2')
        .get(`${url}`)
        .then((response) => {
          commit('setPricing', response.data.data);
          return response;
        });
    },

    async loadCurrentSubscription({ commit }, { churchId }) {
      const url = resolveWellKnownEndpoint('admin_api.v2.organisations.product_subscriptions', {
        organisation_id: churchId,
        product_slug: process.env.VUE_APP_GOTEDO_VINEYARD_ID,
      })?.url;

      if (!url) {
        return;
      }

      return $http('v2')
        .get(`${url}`)
        .then((response) => {
          commit('setCurrentSubscription', response.data.data);

          return response;
        });
    },
  },
};
